import { css } from '@emotion/css'
import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import React, { useState } from 'react'
import InputField from 'src/components/customElements/InputField/InputField'
import InstallationRequestStore from 'src/views/RequestsManagement/stores/InstallationRequestStore'
import AssignedDealer from '../../../../../components/customElements/RequestDataAccordions/AssignedDealer'
import ChangeInstallationDate from '../../../../../components/customElements/RequestDataAccordions/ChangeInstallationDate'
import FinancialSourceAccordion from '../../../../../components/customElements/RequestDataAccordions/FinancialSourceAccordio'
import HasDuplicates from '../../../../../components/customElements/RequestDataAccordions/HasDuplicates'
import InstallationData from '../../../../../components/customElements/RequestDataAccordions/InstallationData'
import IsSuspicious from '../../../../../components/customElements/RequestDataAccordions/IsSuspicious'
import RequestInfo from '../../../../../components/customElements/RequestDataAccordions/RequestInfo'
import SetEquipmentId from '../../../../../components/customElements/RequestDataAccordions/SetEquipmentId'
import UploadedPhotos from '../../../../../components/customElements/RequestDataAccordions/UploadedPhotos'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import CommentsBlock from '../../../../../components/RequestCommentsBlock/CommentsBlock'
import {
  isAdmin,
  isAdministration,
  isAdminLabelAA,
  isDealer,
  isLooker,
  isOperator,
  isSuperOperator,
} from '../../../../../services/AccountService'
import commonStyles from '../../../../../styles/commonStyles'
import { gState } from '../../../../../utils/controllers/GlobalStateController'
import { isModalOpen } from '../../../../../utils/controllers/ModalController'
import { getStyles } from '../../../../../utils/utils/commonUtils'
import TakeReleaseBtn from '../../../../Service/components/Drawers/DrawersCommonComponents/Buttons/TakeReleaseBtn'
import { changeOperatorStatusStore } from '../../ChangeOperatorStatusDrawer/ChangeOperatorStatusStore'
import PhotosUpload from '../../utils/PhotosUpload'

function DefaultContent({
  store,
  ordersStore,
  operatorStore,
  filterStore,
  setUpdateHistory,
  updateHistory,
  setUpdateComment,
  updateComment,
}) {
  const classes = getStyles(commonStyles)
  const intl = gState['intl']
  const isOperatorTable =
    isOperator() && [0].includes(operatorStore.selectedTab)
  const {
    data,
    toAssignDealerView,
    toEditDataView,
    changeFinancialSource,
    changeInstallationDate,
    setOrderDataRequest,
  } = store

  const {
    status,
    id,
    isTakenByMe,
    installationDate,
    dataCheckingStatus,
    reportStatus,
    isCallCenterAuthor,
  } = data
  const [installationRequestStore] = useState(
    () => new InstallationRequestStore({ ordersStore }),
  )

  const photoSettings = installationRequestStore.photoSettings?._photoSettings

  const changeCreationDateCallback = () => {
    store.ordersStore.updateOrder(id).then((res) => store.setData(res))
  }

  const installationDateInclude = () => {
    return [6, 9, 12, 13, 14, 15, 16].includes(status)
  }

  const notRenderDataInstall = () => {
    switch (true) {
      case isAdmin():
        return [1, 2, 4, 5].includes(status)
      case isOperator():
        return false
      default:
        return true
    }
  }

  const displayHasDuplicates = () => {
    switch (true) {
      case isAdmin():
        return true
      case isAdministration() || isOperator():
        return status === 1 || (status === 11 && isTakenByMe)
      default:
        return false
    }
  }
  const AdministrationView = isAdministration() && [7, 11].includes(status)
  const showDealer = isAdmin() || (isOperator() && ![7, 10].includes(status))

  return (
    <Box
      name={'content'}
      className={classNames('fx-col jst-sb', css(classes.drawerContent))}
    >
      {showDealer && status !== 10 ? (
        <AssignedDealer
          request={data}
          defaultOpenState={true}
          onEdit={
            !isOperator() && [1, 2, 4, 7, 11].includes(status)
              ? isLooker() && [1, 2, 4, 7, 11].includes(status)
                ? null
                : toAssignDealerView
              : null
          }
        />
      ) : null}
      {isAdmin() &&
      status !== 1 &&
      status !== 2 &&
      status !== 4 &&
      status !== 7 &&
      status !== 10 ? (
        <SetEquipmentId
          store={store}
          inputsValues={filterStore.data}
          updateHistory={updateHistory}
          setUpdateHistory={setUpdateHistory}
        />
      ) : null}
      {!AdministrationView && <RequestInfo request={store.data} />}
      {isAdministration() &&
        status === 11 &&
        operatorStore.selectedTab === 1 && <RequestInfo request={store.data} />}
      <InstallationData
        onEdit={
          (isAdmin() &&
            ![12, 15, 16].includes(status) &&
            [4, 102, 200].includes(reportStatus)) ||
          (isAdmin() && [1, 2, 4, 5, 6, 7, 9, 10, 11, 13].includes(status)) ||
          (isOperator() &&
            (isTakenByMe || (status === 1 && isCallCenterAuthor))) ||
          (isAdministration() && status === 1) ||
          (isAdministration() &&
            status === 11 &&
            operatorStore.selectedTab === 1 &&
            isTakenByMe) ||
          (isAdminLabelAA() &&
            [1, 2, 4, 5, 6, 7, 9, 10, 11, 13, 15, 16].includes(status) &&
            ![5, 100, 101].includes(reportStatus))
            ? isLooker()
              ? null
              : toEditDataView
            : null
        }
        order={store.data}
        defaultOpenState
        drawerOpen={isModalOpen['request-details']}
        filterStore={filterStore}
        operatorStore={operatorStore}
        ordersStore={ordersStore}
      />
      {isOperator() || notRenderDataInstall() || isOperatorTable ? null : (
        <CustomAccordion
          defaultOpenState={isDealer() && status === 5}
          summary={intl.formatMessage({ id: 'Данные установки' })}
        >
          {(isDealer() || isAdmin()) && installationDateInclude() && (
            <ChangeInstallationDate
              requestId={id}
              requestStatus={status}
              reportStatus={reportStatus}
              inputData={installationDate}
              changeInstallationDate={changeInstallationDate}
              reloadAction={changeCreationDateCallback}
              reportOrder={!!dataCheckingStatus && status !== 6}
              setUpdateHistory={setUpdateHistory}
              setUpdateComment={setUpdateComment}
              store={store}
              ordersStore={ordersStore}
            />
          )}

          <UploadedPhotos store={store} defaultOpenState={true} order={data} />

          {isAdminLabelAA() &&
            [4, 102, 200].includes(reportStatus) &&
            [15, 16].includes(status) && (
              <Box mt={2} mb={1}>
                <PhotosUpload
                  store={installationRequestStore}
                  isReportedOrderUpload={true}
                  title={intl.formatMessage(
                    {
                      id: `Загрузите от {minimumLimit} до {maximumLimit} фотографий`,
                      defaultMessage: `Загрузите от {minimumLimit} до {maximumLimit} фотографий`,
                    },
                    {
                      minimumLimit:
                        photoSettings['reportedEdit']?.minLimitPerLoad,
                      maximumLimit:
                        photoSettings['reportedEdit']?.maxLimitPerLoad,
                    },
                  )}
                />

                {installationRequestStore.data.images.reportedEdit.length >
                  0 && (
                  <InputField
                    error={!store.comment}
                    multiline
                    value={store.comment}
                    onChange={store.setComment}
                    rows={4}
                    fullWidth
                    placeholder={intl.formatMessage({
                      id: 'Введите комментарий',
                    })}
                  />
                )}

                {installationRequestStore.data.images.reportedEdit.length >
                  0 && (
                  <Box className={'jst-sa'} sx={{ gap: '8px' }}>
                    <Button
                      onClick={() => {
                        store.editReported(
                          installationRequestStore.data.images.reportedEdit,
                          () => {
                            installationRequestStore.data.images.reportedEdit =
                              []
                            setUpdateComment((prev) => !prev)
                            setUpdateHistory((prev) => !prev)
                          },
                        )
                      }}
                      disabled={!store.comment}
                      color={'primary'}
                      variant={'contained'}
                      fullWidth
                    >
                      {intl.formatMessage({
                        id: 'Применить изменения',
                      })}
                    </Button>
                    <Button
                      onClick={() => {
                        installationRequestStore.data.images.reportedEdit = []
                      }}
                      color={'primary'}
                      variant={'contained'}
                      fullWidth
                    >
                      {intl.formatMessage({ id: 'Отмена' })}
                    </Button>
                  </Box>
                )}
              </Box>
            )}
        </CustomAccordion>
      )}
      <CommentsBlock store={store} updateComment={updateComment} />
      <FinancialSourceAccordion
        changeFinancialSource={changeFinancialSource}
        onEdit={
          isLooker()
            ? false
            : (isAdmin() && [1, 2].includes(status)) ||
              (isAdministration() && [1, 2].includes(status)) ||
              (isOperator() && status === 1 && isCallCenterAuthor)
        }
        data={data}
      />
      {displayHasDuplicates() && (
        <HasDuplicates data={data} onChange={setOrderDataRequest} />
      )}
      {isAdmin() && <IsSuspicious data={data} onChange={setOrderDataRequest} />}
      {isOperatorTable ||
      (isAdministration() &&
        status === 11 &&
        operatorStore.selectedTab === 1) ? (
        <TakeReleaseBtn data={data} store={operatorStore} />
      ) : null}
      {isSuperOperator() && data?.status === 1 && (
        <Button
          variant='outlined'
          onClick={() => {
            changeOperatorStatusStore.setIsOpen(true)
            changeOperatorStatusStore.setRequestId(data.id)
          }}
          sx={{ margin: '16px' }}
        >
          Перевести в дубликат
        </Button>
      )}
    </Box>
  )
}

export default observer(DefaultContent)
